import * as Cesium from 'cesium';

/**
 * Returns an imagery provider for the globe.
 *
 * - If a Cesium ion token is supplied, returns ion's Bing Aerial
 *   (asset 3) — the high-detail commercial path.
 * - Otherwise returns Cesium's bundled Natural Earth II tiles —
 *   served from `/build/cesium/Assets/Textures/NaturalEarthII`,
 *   shipped as part of every Vite build via vite-plugin-cesium.
 *   Zero network dependencies, zero quota, robust against the
 *   OSM tile-policy rate limits + UA-string requirements that
 *   were producing "white globe, no imagery" symptoms on some
 *   networks. Lower detail than ion/OSM but sufficient at any
 *   typical globe-from-orbit framing (zoom level ≤ 3).
 *
 * The Cesium ion guardrail (`tests/E2E/no-ion-token.spec.ts`)
 * asserts no `*.cesium.com` requests during the test suite —
 * Natural Earth II keeps that contract since it loads from the
 * local build output, not ion.
 */
export async function createImageryProvider(
  cesiumIonToken: string
): Promise<Cesium.ImageryProvider> {
  if (cesiumIonToken) {
    Cesium.Ion.defaultAccessToken = cesiumIonToken;
    return Cesium.IonImageryProvider.fromAssetId(3);
  }

  return Cesium.TileMapServiceImageryProvider.fromUrl(
    Cesium.buildModuleUrl('Assets/Textures/NaturalEarthII')
  );
}
